import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Ensure jwtDecode is imported

// 🔹 Logout function
const handleLogout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("clientId");
  localStorage.removeItem("refAuthToken");
  localStorage.removeItem("current_page");

  // redirect to login page
  window.location.href = "https://crm.finedge.in/?logout=true";
};

let cachedIP = null;
const getIP = async () => {
  // 1️⃣ Return from cache if already fetched
  if (cachedIP) return cachedIP;

  // 2️⃣ Check in localStorage
  const storedIP = localStorage.getItem("user_ip");
  if (storedIP) {
    cachedIP = storedIP;
    return cachedIP;
  }

  // 3️⃣ Fetch once from server
  // try {
  //   const response = await fetch("https://www.finedge.in/home/getRemoteHeaders");
  //   const data = await response.json();
  //   if (data?.ip) {
  //     cachedIP = data.ip;
  //     localStorage.setItem("user_ip", data.ip);
  //     console.log("🌐 Current IP fetched:", data.ip);
  //     return data.ip;
  //   } else {
  //     console.warn("⚠️ No IP found in response");
  //     return null;
  //   }
  // } catch (err) {
  //   console.error("❌ Failed to fetch IP:", err.message);
  //   return null;
  // }
};



// 🔹 Create an instance of axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  timeout: 120000,
});

// 🔹 Request interceptor
api.interceptors.request.use(
  async(config) => {
    try {
      const token = localStorage.getItem("authToken");
      const otp_flag = localStorage.getItem("otp_flag") || 'true'; // Default to 'true' if not found
      const currentIP = await getIP() // Default to 'true' if not found



      if (token) {
        // Optionally decode for debugging
        try {
          const decodedToken = jwtDecode(token);
          // console.log("Decoded Token:", decodedToken);

          // ✅ Check token expiry before request
          if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
            console.warn("⛔ Token expired (from jwtDecode), logging out...");
            handleLogout();
            return Promise.reject(new Error("Token expired"));
          }
        } catch (decodeError) {
          console.warn("Failed to decode token:", decodeError.message);
        }

        // Add Authorization header
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.error("No authentication token found in localStorage.");
      }
      config.headers['otp-flag'] = otp_flag;
      config.headers['remote-ip'] = currentIP;
    } catch (error) {
      console.error("Error in request interceptor:", error.message);
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error.message);
    return Promise.reject(error);
  }
);

// 🔹 Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("API error:", error.response.data);

      // ✅ Check if Unauthorized (token expired or invalid)
      if (error.response.status === 401) {
        console.warn("⛔ Token expired/invalid from API response, logging out...");
        handleLogout();
      }
    } else {
      console.error("API error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
